require('./userNotificationsSectionList.scss');

//@ vendor
const React = require('react');
const PropTypes = require('prop-types');
const trim = require('lodash/string/trim');
const Immutable = require('immutable');

// @ commons
const { FormattedText } = require('core/i18n').i18n;

// @ components
const UserNotificationsContentList = require('components/userNotifications/userNotificationsContentList/userNotificationContentList');

//@constants
const {
    NOTIFICATIONS_STATUS_READ,
    NOTIFICATION_MESSAGE_TYPE_DISCLAIMER,
} = require('constants/index');

class UserNotificationsSectionList extends React.Component {

    constructor(props) {
        super(props);
        this.msgTypeIsNotDisclaimer = this.msgTypeIsNotDisclaimer.bind(this);
        this.buildUserNotificationContentList = this.buildUserNotificationContentList.bind(this);
        this.handleNavigation = this.handleNavigation.bind(this);
    }

    msgTypeIsNotDisclaimer(messageType) {
        return trim(messageType).toUpperCase() !== NOTIFICATION_MESSAGE_TYPE_DISCLAIMER;
    }

    handleNavigation(isError) {
        if(isError) {
            this.setState({
                errorInReferenceNavigation: true
            });
        }
        this.setState({
            isVisible: false
        });
    }

    distributeNotificationByType(notificationData) {
        let notificationResult = {readTitle:[], unreadTitle:[]};
        notificationData.map(notification => {
            if(notification.get('deliveryStatus') === NOTIFICATIONS_STATUS_READ){
                notificationResult.readTitle.push(notification);
            } else {
                notificationResult.unreadTitle.push(notification);
            }
        });

        return notificationResult;
    }

    buildUserNotificationContentList(notifications) {
        const {
            flagBasedFeatures,
            getChoreDetail,
            immCards,
            openYoungCardChores,
            getMoneyRequestDetails,
            moneySavingsRequestDetails
        } = this.props
        return (
            <UserNotificationsContentList
                flagBasedFeatures={flagBasedFeatures}
                getChoreDetail={getChoreDetail}
                getMoneyRequestDetails={getMoneyRequestDetails}
                moneySavingsRequestDetails={moneySavingsRequestDetails}
                immCards={immCards}
                immUserNotifications={Immutable.fromJS({notifications: notifications})}
                openYoungCardChores={openYoungCardChores}
                onHandleNavigation={this.handleNavigation}
                classNames="user-notifications-section-list__content"
            />
        );
    }

    buildUserNotificationsContentViewSection(notificationType, notifications, value) {
        const notificationTypeLabel = `userNotificationsSection-${notificationType}`;
        let notificationPanel;
        if(value.length > 0) {
            notificationPanel = (
                <div>
                    <div className="ok-table-group-header user-notifications-section-list__group-header">
                        <FormattedText value={notificationTypeLabel} />
                    </div>

                    <ul className="user-notifications-section-list__container">
                        {this.buildUserNotificationContentList(notifications[notificationType])}
                    </ul>
                </div>
            );
        }
        return notificationPanel;
    }

    buildUserNotificationsContent() {
        const { immUserNotifications } = this.props;
        const immNotificationsList = immUserNotifications.get('notifications');
        let dataToRender;

        if (immNotificationsList.size > 0) {
            const validNotificationsToDisplay = immNotificationsList.filter(immNotification => {
                const notificationType = immNotification.get('messageType');
                return this.msgTypeIsNotDisclaimer(notificationType);
            });
            //Prepare list for read and unread notifications
            const distributedNotificationByTypeList =  this.distributeNotificationByType(validNotificationsToDisplay);

            dataToRender = (
                <div>
                    {
                     this.buildUserNotificationsContentViewSection('unreadTitle', distributedNotificationByTypeList, distributedNotificationByTypeList.unreadTitle)
                    }
                    {
                     this.buildUserNotificationsContentViewSection('readTitle', distributedNotificationByTypeList, distributedNotificationByTypeList.readTitle)
                    }

                </div>
            );
        } else {
            dataToRender = (
                <div className="text-center user-notifications-section-list__empty">
                    <div className="user-notifications-section-list__empty-header">
                        <FormattedText value="userNotifications-emptyTitle" />
                    </div>
                    <FormattedText value="userNotifications-emptyContent" />
                </div>
            );
        }
        return dataToRender;
    }

    render() {
        return (
            <div className="row no-outside-gutter">
                <div className="col-xs-12 user-notifications-section-list__container">
                    {this.buildUserNotificationsContent()}
                </div>
            </div>
        );
    }
}

UserNotificationsSectionList.propTypes = {
    flagBasedFeatures: PropTypes.object,
    getChoreDetail: PropTypes.func.isRequired,
    getMoneyRequestDetails: PropTypes.func,
    immCards: PropTypes.object.isRequired,
    immUserNotifications: PropTypes.object.isRequired,
    moneySavingsRequestDetails: PropTypes.func.isRequired,
    openYoungCardChores: PropTypes.object.isRequired,
    requestUserNotifications: PropTypes.func
};

module.exports = UserNotificationsSectionList;
